export const PRODUCT_CLICKED = 'product_click';
